function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarmartlogo003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "831px",
    height: "111px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f84af",
    d: "M 66.5,8.5 C 74.5,8.5 82.5,8.5 90.5,8.5C 90.5,14.8333 90.5,21.1667 90.5,27.5C 76.8575,26.0891 63.5242,27.5891 50.5,32C 36.9195,38.4756 32.4195,48.9756 37,63.5C 43.3418,72.9328 52.1751,78.7661 63.5,81C 72.4538,82.2644 81.4538,82.7644 90.5,82.5C 90.5,88.5 90.5,94.5 90.5,100.5C 71.9,102.057 53.9,99.557 36.5,93C 24.1928,86.6941 15.3595,77.1941 10,64.5C 6.739,48.1734 11.5723,34.6734 24.5,24C 37.1228,14.9606 51.1228,9.79397 66.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f84af",
    d: "M 173.5,8.5 C 193.934,38.5147 214.267,68.6813 234.5,99C 225.524,100.207 216.524,100.54 207.5,100C 196.333,84.8333 185.167,69.6667 174,54.5C 163.377,69.5795 152.877,84.7462 142.5,100C 132.833,100.667 123.167,100.667 113.5,100C 134.142,69.8703 154.142,39.3703 173.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f84af",
    d: "M 252.5,8.5 C 271.864,8.12303 291.198,8.62303 310.5,10C 326.311,12.6444 335.644,21.8111 338.5,37.5C 338.031,41.0743 336.864,44.4076 335,47.5C 330.455,52.5118 325.621,57.1784 320.5,61.5C 328.167,74.1667 335.833,86.8333 343.5,99.5C 333.851,100.665 324.184,100.832 314.5,100C 307.249,88.8341 300.249,77.5008 293.5,66C 288.845,65.5008 284.179,65.3342 279.5,65.5C 279.5,77.1667 279.5,88.8333 279.5,100.5C 270.5,100.5 261.5,100.5 252.5,100.5C 252.5,82.5 252.5,64.5 252.5,46.5C 268.837,46.6666 285.17,46.4999 301.5,46C 311.774,42.8653 313.441,37.532 306.5,30C 304.608,29.0266 302.608,28.3599 300.5,28C 284.503,27.5001 268.503,27.3334 252.5,27.5C 252.5,21.1667 252.5,14.8333 252.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606160",
    d: "M 428.5,8.5 C 436.833,8.5 445.167,8.5 453.5,8.5C 453.5,39.1667 453.5,69.8333 453.5,100.5C 444.833,100.5 436.167,100.5 427.5,100.5C 427.667,81.4971 427.5,62.4971 427,43.5C 415.667,55.5 404.333,67.5 393,79.5C 381.638,67.8035 369.971,56.4702 358,45.5C 357.333,34.1667 357.333,22.8333 358,11.5C 369.971,22.4702 381.638,33.8035 393,45.5C 404.673,32.9944 416.506,20.6611 428.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606160",
    d: "M 615.5,8.5 C 634.867,8.10727 654.2,8.60727 673.5,10C 689.363,12.6972 698.696,21.8639 701.5,37.5C 701.705,40.7946 700.872,43.7946 699,46.5C 694.62,52.3815 689.453,57.3815 683.5,61.5C 691.302,74.4662 699.302,87.2995 707.5,100C 697.833,100.667 688.167,100.667 678.5,100C 671.167,88.6667 663.833,77.3333 656.5,66C 651.845,65.5008 647.179,65.3342 642.5,65.5C 642.5,77.1667 642.5,88.8333 642.5,100.5C 633.5,100.5 624.5,100.5 615.5,100.5C 615.5,82.5 615.5,64.5 615.5,46.5C 631.837,46.6666 648.17,46.4999 664.5,46C 674.01,43.9928 676.344,38.9928 671.5,31C 669.283,29.7246 666.949,28.7246 664.5,28C 648.17,27.5001 631.837,27.3334 615.5,27.5C 615.5,21.1667 615.5,14.8333 615.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606160",
    d: "M 711.5,8.5 C 748.167,8.5 784.833,8.5 821.5,8.5C 821.5,14.8333 821.5,21.1667 821.5,27.5C 807.5,27.5 793.5,27.5 779.5,27.5C 779.5,51.8333 779.5,76.1667 779.5,100.5C 770.833,100.5 762.167,100.5 753.5,100.5C 753.5,76.1667 753.5,51.8333 753.5,27.5C 739.5,27.5 725.5,27.5 711.5,27.5C 711.5,21.1667 711.5,14.8333 711.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606160",
    d: "M 532.5,9.5 C 534.074,9.93709 535.241,10.9371 536,12.5C 555.128,41.9249 574.628,71.0916 594.5,100C 584.5,100.667 574.5,100.667 564.5,100C 554.696,84.6979 544.696,69.5312 534.5,54.5C 523.6,69.2866 512.933,84.2866 502.5,99.5C 492.833,100.833 483.167,100.833 473.5,99.5C 493.193,69.4823 512.859,39.4823 532.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb03f",
    d: "M 173.5,68.5 C 182.04,77.8878 189.373,88.2211 195.5,99.5C 181.178,100.666 166.845,100.833 152.5,100C 159.634,89.5574 166.634,79.0574 173.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb03f",
    d: "M 533.5,68.5 C 540.97,78.8206 548.304,89.3206 555.5,100C 540.833,100.667 526.167,100.667 511.5,100C 519.443,89.8965 526.776,79.3965 533.5,68.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarmartlogo003);
export default __webpack_public_path__ + "static/media/Carmart logo (003).e385824ffa8888b943649b6b23ef03fc.svg";
export { ForwardRef as ReactComponent };